import { useEffect, useState } from 'react';
import useClient from '../../../api/client';
import { useAlert } from 'components/message/AlertContext';
import listDatasets from 'api/Dataset/listDatasets';
import { SearchFilter } from 'types/Filters';
import { DatasetListResult } from 'types/Dataset';

export default function useDatasetList(
    filter: SearchFilter,
    sharesFilter: SearchFilter,
) {
    const client = useClient() as unknown as {
        query: (query: any) => Promise<any>;
    };
    const { openAlert } = useAlert();

    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState<DatasetListResult>({
        nodes: [],
        count: 0,
        page: 0,
        pages: 0,
    });
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await client?.query(
                    listDatasets(filter, sharesFilter),
                );
                if (!response.errors) {
                    setItems(response.data.listDatasets);
                } else {
                    setError(true);
                    openAlert({
                        message:
                            'Something went wrong... Could not retrieve datasets',
                        severity: 'alert',
                    });
                }
            } catch (error) {
                setError(true);
                openAlert({
                    message: 'An error occurred while fetching datasets',
                    severity: 'alert',
                });
            } finally {
                setLoading(false);
            }
        };

        if (client) {
            fetchData();
        }
    }, [client, filter]);

    return { items, error, loading };
}
